/**
 * 判断对象或者数组，是否为null、unkn、空
 * */
export function empty (objOrArr) {
  return isEmptyObj(objOrArr)
}
export function notEmpty (objOrArr) {
  return !isEmptyObj(objOrArr)
}
// 如果str非有效字符串，转换成def
export function trimDefualt (str, def) {
  if (typeof (str) !== 'string' && str !== undefined) { return str }
  return str === undefined || str.toLowerCase() === 'null' || str === '' ? def : str
}

// 判断 {}、[] 是否为空
function isEmptyObj (e) {
  if (e === undefined) return true
  for (let t in e) return false
  return true
}

//去除字符串中的所有空格
export const trim = (text) => {
  return text.replace(/\s/ig,'')
}

// 判断str是否为有效字符串
export const ifStrBlank = (str, len) => {
  if (typeof (str) === 'undefined' || str == null || str === '') {
    return true
  }
  str = str.replace(/^\s\s*/, '').replace(/\s\s*$/, '').toLowerCase()
  if (str === '' || str === 'null' || str === 'undefined') {
    return true
  }
  if (typeof (len) !== 'undefined' && str.length !== len) {
    return true
  }
  return false
}
export const ifStrNotBlank = (str, len) => {
  return !ifStrBlank(str, len)
}

/**
 * @desc   url参数转对象
 * @param  {String} url  default: window.location.href
 * @return {Object} obj
 */
export const parseQueryString = (url) => {
  var obj = {}
  try {
    url = url === null || url === undefined ? window.location.href : url
    // http://app.tmc.zbss.com/?t=1692329355821/#/home?token=
    // 处理上述地址 t用来解决缓存问题
    var h = url.indexOf('/#/')
    var i = url.indexOf('?')
    if (h > i) {
      i = url.lastIndexOf('?')
      if (h > i) {
        i = -1
      }
    }
    var search = ''; var kvs = []
    if (i === -1) {
      search = url
    } else {
      search = url.substring(i + 1) || ''
      kvs = search.split('&') || []
    }
    for (var j = 0, l = kvs.length; j < l; j++) {
      var kv = kvs[j].split('=')
      obj[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]) || ''
    }
  } catch (error) {
    return obj
  }
  return obj
}

/**
 * @desc   过滤特殊字符
 * @param  {String} 需要过滤字符
 * @return {String} 过滤后的字符串
 */
export const specialStr = (str) => {
  var pattern = new RegExp('[`~!@#$^&*()=|{}\':;\',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“\'。，、？%+_]')
  var specialStr = ''
  for (var i = 0; i < str.length; i++) {
    specialStr += str.substr(i, 1).replace(pattern, '')
  }
  return specialStr
}

//去掉字符串中的特殊字符
export const excludeSpecial =  (s) =>{
  if (s) {
    s = s.replace(/\s/g,'')//去掉所有的空格（中文空格、英文空格都会被替换）
    s = s.replace(/[ ]/g, '')//去掉空格
    s = s.replace(/[\r\n]/g, '') //去掉回车换行
    // 去掉转义字符
    s = s.replace(/[\'\"\\\/\b\f\n\r\t]/g, '')
    // 去掉特殊字符
    s = s.replace(/[\@\#\$\%\^\&\*\(\)\{\}\:\"\L\<\>\?\[\]]/g,'')
  }
  return s
}

/**
	* @desc 字符串替换 传入的标识符
	* @param {String|Number} str 字符串或数字
	* @param {String} symbol 需要替换的字符串 '*'
	* @param {String|Array} range 需要替换的字符串, 传入数字且‘,’分隔的字符串（'2,5,6'）为指定位置替换。传入数组为指定区间([2,5])替换。
	*/
export const replaceSymbol = (val, symbol, range) => {
  if (typeof val != 'string') val = String(val)

  if (typeof range == 'string') {
    var indexs = range.split(','),
      rt = '',
      start = 0

    for (var i = 0; i < indexs.length; i++) {
      var index = Number(indexs[i])

      rt += val.substring(start, index)

      if (index < val.length) {
        rt += symbol
        start = index + 1
      } else {
        break
      }
    }

    return rt
  } else {
    var startLen = range[0],
      endLen = val.length - range[1] - 1,
      diff = range[1] - startLen + 1
    var reg = new RegExp('^(\\d{' + startLen + '})\\d{' + diff + '}(\\d{' + endLen + '})$')

    var rs = ''
    while (diff > 0) {
      rs += symbol
      diff--
    }

    val = val.replace(reg, '$1' + rs + '$2')
    return val
  }
}

// 米 转 公里   例如：2320 -> 2.3
export const metreToKm = function (metre) {
  metre = parseInt(metre)
  let intger = Math.floor(metre / 1000)
  let decimal = parseFloat((metre % 1000 / 1000).toFixed(1))
  return intger + decimal
}
